import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Row, Col } from 'react-bootstrap';
import Truncate from 'react-truncate';
import { Link } from 'react-router-dom';

class LinkedArticlesList extends Component {
  render() {
    return (
      <Row>
        <Col lg={12} className="article-list">
          {this.props.articles.map(article => (
            <div key={article.id} className="article-item">
              <Link to={`/article/${article.id}`} className="overlay">
                <Truncate lines={2} ellipsis={<span>...</span>}>
                  {article.title}
                </Truncate>
              </Link>
              <img src={article.link.image} className="article-img"/>
            </div>
          ))}
        </Col>
      </Row>
    );
  }
}

LinkedArticlesList.propTypes = {
  articles: PropTypes.array.isRequired
};

export default LinkedArticlesList;



// WEBPACK FOOTER //
// ./src/components/common/article/linked-articles-list.jsx